export const addToast = (toast) => ({
  type: "TOAST_ADDED",
  payload: toast
});

export const removeToast = (toast) => ({
  type: "TOAST_REMOVED",
  payload: toast
});
